import { type ReactNode } from 'react';
import { type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const SelectionAction = ({
  icon: Icon,
  tooltip,
  dataCy,
  onClick,
  disabled = false,
}: {
  icon: LucideIcon;
  tooltip?: ReactNode;
  dataCy: string;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <Button
    variant="secondary-toolbar"
    size="secondary-toolbar"
    onClick={onClick}
    data-cy={dataCy}
    disabled={disabled}
    tooltip={tooltip}
    tooltipClassName="text-balance"
    icon={Icon}
    iconClassName="stroke-text-inverted transition-colors duration-200 group-hover/toolbar-button:stroke-text-base"
  />
);
